<template>
  <div class="pagina ativa" id="paginaConfig">
    <div class="pagina-titulo">Configuracoes</div>

    <div class="config-tabs" role="tablist" aria-label="Seções de configurações">
      <button class="config-tab" :class="{ ativa: abaConfig === 'identidade' }" @click="abaConfig = 'identidade'">
        <span class="config-tab-icon"><Palette :size="16" /></span><span><strong>Identidade</strong><small>Marca e aparência</small></span>
      </button>
      <button class="config-tab" :class="{ ativa: abaConfig === 'usuarios' }" @click="abaConfig = 'usuarios'">
        <span class="config-tab-icon"><Users :size="16" /></span><span><strong>Usuários</strong><small>Acessos e permissões</small></span><em>{{ usuarios.length }}</em>
      </button>
    </div>

    <div v-show="abaConfig === 'identidade'" class="config-panel config-identidade">
      <div style="font-weight:bold;color:#702e46;font-size:15px;margin-bottom:15px;">Identidade do Sistema</div>

      <label style="font-size:12px;font-weight:bold;color:#555;">NOME DA EMPRESA</label>
      <input type="text" v-model="nomeEmpresaForm" placeholder="Nome da sua empresa" style="margin-bottom:6px;" />
      <p style="font-size:11px;color:#888;margin:0 0 12px;">Aparece na tela de login, no menu lateral e nas propostas. Deixe em branco para usar o nome de cadastro da empresa.</p>
      <button class="config-btn-primary" :disabled="salvandoNome" @click="salvarNomeEmpresa">Salvar nome da empresa</button>
      <div class="status" :class="statusNomeClasse">{{ statusNome }}</div>

      <div style="border-top:1px solid #eee;margin:18px 0 15px;"></div>

      <label style="font-size:12px;font-weight:bold;color:#555;">COR DO SISTEMA</label>
      <p style="font-size:11px;color:#888;margin:4px 0 10px;">Define a cor principal (botões, destaques, menu) usada após o login.</p>
      <div style="display:flex;align-items:center;gap:12px;margin-bottom:10px;">
        <input type="color" v-model="corTemaForm" style="width:52px;height:42px;padding:2px;border-radius:8px;cursor:pointer;" />
        <input type="text" v-model="corTemaForm" placeholder="#702e46" style="flex:1;margin:0;" />
      </div>
      <button class="config-btn-primary" :disabled="salvandoCor" @click="salvarCorTema">Aplicar cor do sistema</button>
      <div class="status" :class="statusCorClasse">{{ statusCor }}</div>

      <div style="border-top:1px solid #eee;margin:18px 0 15px;"></div>

      <div style="margin-bottom:15px;text-align:center;">
        <img v-if="logoAtual" :src="logoAtual" style="max-width:150px;max-height:150px;border-radius:8px;" />
        <p v-else style="color:#aaa;">Sem logo</p>
      </div>
      <div class="area-upload" @click="$refs.inputLogo.click()" style="margin-bottom:15px;">
        <div>{{ nomeLogoArquivo || 'Selecionar imagem' }}</div>
      </div>
      <input type="file" ref="inputLogo" accept="image/*" @change="selecionarLogo" style="display:none;" />
      <button class="config-btn-primary" :disabled="!logoBase64" @click="salvarLogoSistema">Salvar nova logo</button>
      <div class="status" :class="statusLogoClasse">{{ statusLogo }}</div>
    </div>

    <div v-show="abaConfig === 'usuarios'" class="config-panel config-usuarios">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
        <div style="display:flex;align-items:center;gap:8px;font-weight:800;color:#302330;font-size:16px;"><Users :size="18" /> Gestão de Usuários</div>
        <button class="config-btn-new" :disabled="limiteAtingido" :title="limiteAtingido ? 'Limite de usuarios do plano atingido' : ''" @click="abrirModalUsuario(-1)">
          <span style="font-size:16px;line-height:1;">+</span> Novo
        </button>
      </div>
      <div v-if="limiteUsuarios !== null" style="font-size:12px;color:#888;margin-bottom:14px;">
        {{ totalAtivos }} de {{ limiteUsuarios }} usuário(s) do plano
        <span v-if="limiteAtingido" style="color:#c0392b;font-weight:bold;"> — limite atingido. Fale com o suporte para liberar mais vagas.</span>
      </div>

      <p v-if="carregando" style="color:#aaa;text-align:center;padding:30px;">Carregando...</p>
      <p v-else-if="usuarios.length === 0" style="color:#aaa;text-align:center;padding:30px;">Nenhum usuário cadastrado.</p>
      <div v-for="u in usuarios" :key="u.indice" class="config-user-card" :class="{ inativo: !u.ativo }">
        <div :style="{ position: 'absolute', top: 0, left: 0, width: '4px', height: '100%', background: u.perfil === 'admin' ? '#702e46' : '#27ae60', borderRadius: '4px 0 0 4px' }"></div>
        <div style="display:flex;align-items:center;gap:12px;padding-left:8px;">
          <img v-if="u.foto" :src="u.foto" :style="{ width: '46px', height: '46px', borderRadius: '50%', objectFit: 'cover', border: '2px solid ' + (u.perfil === 'admin' ? '#702e46' : '#27ae60'), flexShrink: 0 }" />
          <div v-else :style="{ width: '46px', height: '46px', borderRadius: '50%', background: u.perfil === 'admin' ? '#702e46' : '#27ae60', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: 800, color: 'white', flexShrink: 0 }">{{ iniciais(u.nome) }}</div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:15px;font-weight:800;color:#302330;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.nome }}</div>
            <div style="font-size:12px;color:#888;margin-top:1px;">@{{ u.usuario }}</div>
            <div v-if="u.pixChave" style="display:flex;align-items:center;gap:4px;font-size:11px;color:#702e46;margin-top:2px;"><KeyRound :size="12" /> PIX: {{ u.pixChave }}<span v-if="u.nomeBanco"> — {{ u.nomeBanco }}</span></div>
          </div>
          <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;">
            <span :style="{ background: u.perfil === 'admin' ? '#702e46' : '#27ae60', color: 'white', padding: '3px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }">{{ u.perfil }}</span>
            <span v-if="!u.ativo" style="background:#fef3c7;color:#92400e;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:700;">Inativo</span>
          </div>
        </div>
        <div style="border-top:1px solid #f0f0f0;margin:12px 0 10px 8px;"></div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:7px;padding-left:8px;">
          <button @click="abrirModalUsuario(u.indice, u)" style="display:inline-flex;align-items:center;justify-content:center;gap:5px;margin:0;padding:9px 0;font-size:12px;font-weight:700;border-radius:9px;background:#702e46;"><Pencil :size="13" /> Editar</button>
          <button @click="toggleStatusUsuario(u)" :style="{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px', margin: 0, padding: '9px 0', fontSize: '12px', fontWeight: 700, borderRadius: '9px', background: u.ativo ? '#e67e22' : '#27ae60' }"><Pause v-if="u.ativo" :size="13" /><Play v-else :size="13" /> {{ u.ativo ? 'Inativar' : 'Ativar' }}</button>
          <button @click="excluirUsuario(u)" style="display:inline-flex;align-items:center;justify-content:center;gap:5px;margin:0;padding:9px 0;font-size:12px;font-weight:700;border-radius:9px;background:#c0392b;grid-column:1/-1;"><Trash2 :size="13" /> Excluir</button>
        </div>
      </div>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>{{ indiceSelecionado === -1 ? 'Novo Usuario' : 'Editar Usuario' }}</h3>
        <label>USUARIO (login)</label><input type="text" v-model="form.usuario" />
        <label>SENHA <span v-if="indiceSelecionado !== -1" style="color:#888;font-weight:normal;font-size:11px;">(branco = nao alterar)</span></label>
        <input type="password" v-model="form.senha" />
        <label>NOME</label><input type="text" v-model="form.nome" />
        <label>PERFIL</label>
        <select v-model="form.perfil"><option value="vendedor">Vendedor</option><option value="admin">Admin</option></select>
        <label>% COMISSAO</label>
        <input type="text" inputmode="decimal" v-model="form.comissao" placeholder="50" @input="form.comissao = form.comissao.replace(/[^0-9,.]/g,'').replace(',', '.')" style="width:100%;" />
        <label>% IMPOSTO <span style="color:#888;font-weight:normal;font-size:11px;">(descontado da comissao deste usuario)</span></label>
        <input type="text" inputmode="decimal" v-model="form.impostoPct" placeholder="15" @input="form.impostoPct = form.impostoPct.replace(/[^0-9,.]/g,'').replace(',', '.')" style="width:100%;" />
        <label>CHAVE PIX</label>
        <input type="text" v-model="form.pixChave" placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatoria" />
        <label>NOME NO BANCO <span style="color:#888;font-weight:normal;font-size:11px;">(se diferente do nome acima, ex: nome da empresa)</span></label>
        <input type="text" v-model="form.nomeBanco" placeholder="Nome como aparece na conta que recebe o pagamento" />
        <label>ACESSO AO MÓDULO MASTER <span style="color:#888;font-weight:normal;font-size:11px;">(vendido à parte)</span></label>
        <select v-model="form.masterAcesso">
          <option value="">Sem acesso</option>
          <option value="operador">Operador</option>
          <option value="gestor">Gestor</option>
        </select>
        <label style="margin-top:10px;display:flex;align-items:center;justify-content:space-between;">
          <span>TELAS PERMITIDAS</span>
          <span style="display:flex;align-items:center;gap:6px;font-weight:normal;font-size:11px;color:#702e46;cursor:pointer;" @click="form.acessoIrrestrito = !form.acessoIrrestrito">
            <input type="checkbox" v-model="form.acessoIrrestrito" style="width:auto;margin:0;" /> Acesso total
          </span>
        </label>
        <div v-if="!form.acessoIrrestrito" style="border:1px solid #eee;border-radius:8px;padding:10px;max-height:220px;overflow-y:auto;">
          <label v-for="item in menuPaginas" :key="item.id" style="display:flex;align-items:center;gap:8px;font-weight:normal;color:#333;padding:5px 2px;margin:0;text-transform:none;font-size:13px;">
            <input type="checkbox" :value="item.id" v-model="form.paginasPermitidas" style="width:auto;margin:0;" />
            <span style="display:inline-flex;align-items:center;gap:6px;"><component :is="iconesMenu[item.icone]" :size="14" /> {{ item.label }}</span>
          </label>
        </div>
        <p v-else style="color:#888;font-size:11px;margin:0 0 6px;">Usuario vera todas as telas disponiveis para o perfil selecionado.</p>
        <div style="display:flex;align-items:center;gap:12px;margin:14px 0;">
          <img v-if="form.foto" :src="form.foto" style="width:56px;height:56px;border-radius:50%;object-fit:cover;border:2px solid #702e46;" />
          <div v-else style="width:56px;height:56px;border-radius:50%;background:#702e46;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:bold;color:white;flex-shrink:0;">{{ iniciais(form.nome) }}</div>
          <div>
            <button @click="$refs.inputFoto.click()" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 14px;font-size:12px;"><Camera :size="13" /> Selecionar foto</button>
            <button v-if="form.foto" @click="form.foto = ''" style="display:inline-flex;align-items:center;gap:5px;margin:0;margin-left:6px;padding:8px 14px;font-size:12px;background:#c0392b;"><X :size="13" /> Remover</button>
          </div>
        </div>
        <input type="file" ref="inputFoto" accept="image/*" style="display:none;" @change="selecionarFotoUsuario" />
        <div class="status" :class="statusUsuarioClasse">{{ statusUsuario }}</div>
        <div class="app-drawer-acoes">
          <button @click="modalAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarUsuario">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#paginaConfig{max-width:1120px}
.config-tabs{display:flex;gap:10px;margin-bottom:20px;padding:5px;border:1px solid var(--line);border-radius:16px;background:#ece9e3;width:max-content;max-width:100%}
.config-tab{position:relative;display:flex;align-items:center;gap:11px;min-width:190px;margin:0;padding:11px 15px;border:1px solid transparent;border-radius:12px;background:transparent;color:var(--ink-500);box-shadow:none;text-align:left}
.config-tab:hover{background:rgba(255,255,255,.65);color:var(--ink-950);box-shadow:none;transform:none}
.config-tab.ativa{border-color:var(--line);background:#fff;color:var(--ink-950);box-shadow:0 3px 12px rgba(20,18,16,.07)}
.config-tab-icon{display:grid;place-items:center;width:34px;height:34px;border-radius:10px;background:rgba(156,133,104,.11);color:var(--brand-700);font-size:17px}
.config-tab>span:nth-child(2){display:flex;flex-direction:column;gap:2px}.config-tab strong{font-size:12px}.config-tab small{font-size:9px;font-weight:600;color:var(--ink-500)}
.config-tab em{margin-left:auto;display:grid;place-items:center;min-width:23px;height:23px;padding:0 6px;border-radius:8px;background:var(--brand-100);color:var(--brand-700);font-size:10px;font-style:normal;font-weight:800}
.config-panel{border:1px solid var(--line)!important;border-radius:18px!important;background:#fff!important;box-shadow:var(--shadow-sm)!important;padding:26px!important;animation:config-enter .2s ease both}
.config-identidade{max-width:720px}.config-identidade>div:first-child{color:var(--ink-950)!important;font-size:17px!important;letter-spacing:-.02em}
.config-identidade>div[style*="border-top"]{border-color:var(--line)!important;margin:24px 0 20px!important}
.config-identidade p{font-size:11px!important;color:var(--ink-500)!important}
.config-identidade input[type="color"]{border:1px solid var(--line)!important;background:#fff;padding:4px!important}
.config-identidade .area-upload{max-width:none;padding:26px;border-style:dashed;background:var(--brand-50);font-weight:700;color:var(--brand-700)}
.config-identidade img{padding:8px;border:1px solid var(--line);background:#f8f7f4;box-shadow:var(--shadow-sm)}
.config-btn-primary{width:100%;min-height:44px;margin:4px 0 10px;border:1px solid rgba(255,255,255,.12);border-radius:11px;background:linear-gradient(135deg,var(--brand-700),var(--brand-900));box-shadow:0 6px 16px rgba(106,85,60,.15)}
.config-btn-new{display:flex;align-items:center;gap:7px;margin:0;padding:10px 17px;border-radius:11px;background:linear-gradient(135deg,var(--brand-700),var(--brand-900))}
.config-usuarios>div:first-child>div:first-child{color:var(--ink-950)!important;font-size:17px!important}
.config-user-card{position:relative;overflow:hidden;margin-bottom:10px;padding:16px 16px 13px;border:1px solid var(--line);border-radius:14px;background:#fff;transition:border-color .16s,box-shadow .16s,transform .16s}
.config-user-card:hover{border-color:#d1c5b5;box-shadow:0 8px 24px rgba(20,18,16,.07);transform:translateY(-1px)}.config-user-card.inativo{background:#faf9f7;opacity:.72}
.config-user-card button{margin:0!important;padding:9px 12px!important;border-radius:9px!important;font-size:11px!important;box-shadow:none!important}
.config-user-card button:nth-child(1){background:#272a2d!important}.config-user-card button:nth-child(2){background:#aa7a42!important}.config-user-card button:nth-child(3){background:#fff!important;color:#b34943!important;border:1px solid #efd3d0!important}
@keyframes config-enter{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
@media(max-width:600px){.config-tabs{width:100%;overflow-x:auto}.config-tab{min-width:170px}.config-panel{padding:19px!important}.config-user-card{padding:14px}}
</style>

<script>
import { apiGet, apiPost, apiDelete, aplicarCorTema } from '../api'
import { MENU } from '../menu'
import { ICONES_MENU } from '../iconesMenu'
import { Palette, Users, KeyRound, Pencil, Pause, Play, Trash2, Camera, X } from 'lucide-vue-next'

export default {
  name: 'PaginaConfig',
  components: { Palette, Users, KeyRound, Pencil, Pause, Play, Trash2, Camera, X },
  data() {
    return {
      abaConfig: 'identidade',
      logoAtual: '',
      logoBase64: '',
      nomeLogoArquivo: '',
      statusLogo: '',
      statusLogoClasse: '',
      nomeEmpresaForm: '',
      statusNome: '',
      statusNomeClasse: '',
      salvandoNome: false,
      corTemaForm: '#702e46',
      statusCor: '',
      statusCorClasse: '',
      salvandoCor: false,
      usuarios: [],
      carregando: true,
      modalAberto: false,
      indiceSelecionado: -1,
      form: { usuario: '', senha: '', nome: '', perfil: 'vendedor', comissao: '', impostoPct: '15', masterAcesso: '', foto: '', pixChave: '', nomeBanco: '', acessoIrrestrito: true, paginasPermitidas: [] },
      statusUsuario: '',
      statusUsuarioClasse: '',
      limiteUsuarios: null,
      totalAtivos: 0
    }
  },
  computed: {
    iconesMenu() {
      return ICONES_MENU
    },
    menuPaginas() {
      return MENU.filter(m => m.id !== 'config')
    },
    limiteAtingido() {
      return this.limiteUsuarios !== null && this.totalAtivos >= this.limiteUsuarios
    }
  },
  created() {
    this.carregarLogo()
    this.carregarNomeEmpresa()
    this.carregarCorTema()
    this.carregarUsuarios()
  },
  methods: {
    iniciais(nome) {
      const partes = (nome || '?').trim().split(' ')
      return partes.length > 1 ? (partes[0][0] + partes[partes.length - 1][0]).toUpperCase() : (nome || '?').substring(0, 2).toUpperCase()
    },
    async carregarLogo() {
      const r = await apiGet('config/get', { chave: 'LOGO' })
      if (r.sucesso && r.valor) this.logoAtual = r.valor
    },
    async carregarNomeEmpresa() {
      const r = await apiGet('config/get', { chave: 'NOME_EMPRESA' })
      if (r.sucesso) this.nomeEmpresaForm = r.valor || ''
    },
    async salvarNomeEmpresa() {
      this.salvandoNome = true
      this.statusNome = 'Salvando...'
      this.statusNomeClasse = ''
      const r = await apiPost('config/set', { chave: 'NOME_EMPRESA', valor: this.nomeEmpresaForm.trim() })
      this.salvandoNome = false
      if (r.sucesso) {
        this.statusNomeClasse = 'sucesso'
        this.statusNome = 'Nome salvo!'
      } else {
        this.statusNomeClasse = 'erro-msg'
        this.statusNome = r.mensagem || 'Erro ao salvar.'
      }
    },
    async carregarCorTema() {
      const r = await apiGet('config/get', { chave: 'COR_TEMA' })
      if (r.sucesso && r.valor) this.corTemaForm = r.valor
    },
    async salvarCorTema() {
      const hex = this.corTemaForm.trim()
      if (!/^#[0-9a-fA-F]{6}$/.test(hex)) {
        this.statusCorClasse = 'erro-msg'
        this.statusCor = 'Cor inválida. Use um hex completo de 6 dígitos, ex: #702e46.'
        return
      }
      this.salvandoCor = true
      this.statusCor = 'Salvando...'
      this.statusCorClasse = ''
      const r = await apiPost('config/set', { chave: 'COR_TEMA', valor: this.corTemaForm.trim() })
      this.salvandoCor = false
      if (r.sucesso) {
        aplicarCorTema(this.corTemaForm.trim())
        this.statusCorClasse = 'sucesso'
        this.statusCor = 'Cor salva!'
      } else {
        this.statusCorClasse = 'erro-msg'
        this.statusCor = r.mensagem || 'Erro ao salvar.'
      }
    },
    selecionarLogo(e) {
      const f = e.target.files[0]
      if (!f) return
      const r = new FileReader()
      r.onload = (ev) => {
        this.logoBase64 = ev.target.result
        this.nomeLogoArquivo = f.name
        this.logoAtual = this.logoBase64
      }
      r.readAsDataURL(f)
    },
    async salvarLogoSistema() {
      if (!this.logoBase64) return
      this.statusLogo = 'Salvando...'
      this.statusLogoClasse = ''
      const r = await apiPost('config/set', { chave: 'LOGO', valor: this.logoBase64 })
      if (r.sucesso) {
        this.statusLogoClasse = 'sucesso'
        this.statusLogo = 'Logo salvo!'
      } else {
        this.statusLogoClasse = 'erro-msg'
        this.statusLogo = r.mensagem || 'Erro ao salvar.'
      }
    },
    async carregarUsuarios() {
      this.carregando = true
      const r = await apiGet('usuarios/listar-admin')
      if (r.sucesso) {
        this.usuarios = r.usuarios
        this.limiteUsuarios = (r.limiteUsuarios === undefined) ? null : r.limiteUsuarios
        this.totalAtivos = r.totalAtivos || 0
      }
      this.carregando = false
    },
    abrirModalUsuario(indice, u) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      const conteudo = document.querySelector('.conteudo')
      if (conteudo) conteudo.scrollTop = 0
      this.indiceSelecionado = indice
      this.statusUsuario = ''
      if (indice === -1) {
        this.form = { usuario: '', senha: '', nome: '', perfil: 'vendedor', comissao: '', impostoPct: '15', masterAcesso: '', foto: '', pixChave: '', nomeBanco: '', acessoIrrestrito: true, paginasPermitidas: [] }
      } else {
        this.form = {
          usuario: u.usuario, senha: '', nome: u.nome, perfil: u.perfil, comissao: u.comissao || '', impostoPct: (u.impostoPct === undefined || u.impostoPct === null) ? '15' : u.impostoPct.toString(), masterAcesso: u.masterAcesso || '', foto: u.foto || '', pixChave: u.pixChave || '', nomeBanco: u.nomeBanco || '',
          acessoIrrestrito: !Array.isArray(u.paginasPermitidas),
          paginasPermitidas: Array.isArray(u.paginasPermitidas) ? [...u.paginasPermitidas] : []
        }
      }
      this.modalAberto = true
    },
    selecionarFotoUsuario(e) {
      const f = e.target.files[0]
      if (!f) return
      const r = new FileReader()
      r.onload = (ev) => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const MAX = 200
          let width = img.width
          let height = img.height
          if (width > height) {
            if (width > MAX) { height *= MAX / width; width = MAX }
          } else {
            if (height > MAX) { width *= MAX / height; height = MAX }
          }
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          this.form.foto = canvas.toDataURL('image/jpeg', 0.7)
        }
        img.src = ev.target.result
      }
      r.readAsDataURL(f)
    },
    async salvarUsuario() {
      if (!this.form.usuario || !this.form.nome) {
        this.statusUsuarioClasse = 'erro-msg'
        this.statusUsuario = 'Preencha usuario e nome.'
        return
      }
      if (this.indiceSelecionado === -1 && !this.form.senha) {
        this.statusUsuarioClasse = 'erro-msg'
        this.statusUsuario = 'Informe uma senha.'
        return
      }
      const r = await apiPost('usuarios/salvar', {
        id: this.indiceSelecionado,
        usuario: this.form.usuario.trim(),
        senha: this.form.senha,
        nome: this.form.nome.trim(),
        perfil: this.form.perfil,
        comissao: this.form.comissao,
        impostoPct: this.form.impostoPct,
        masterAcesso: this.form.masterAcesso,
        foto: this.form.foto,
        pixChave: this.form.pixChave,
        nomeBanco: this.form.nomeBanco,
        paginasPermitidas: this.form.acessoIrrestrito ? null : this.form.paginasPermitidas
      })
      if (r.sucesso) {
        this.modalAberto = false
        this.carregarUsuarios()
      } else {
        this.statusUsuarioClasse = 'erro-msg'
        this.statusUsuario = r.mensagem || 'Erro ao salvar.'
      }
    },
    async toggleStatusUsuario(u) {
      if (!confirm((u.ativo ? 'Inativar' : 'Ativar') + '?')) return
      const r = await apiPost('usuarios/alterar-status', { id: u.indice, ativo: !u.ativo })
      if (r.sucesso) this.carregarUsuarios()
    },
    async excluirUsuario(u) {
      if (!confirm('Excluir "' + u.nome + '"?')) return
      const r = await apiDelete('usuarios/excluir', { id: u.indice })
      if (r.sucesso) this.carregarUsuarios()
    }
  }
}
</script>
